import { z } from 'zod'

export const CarHirePolicySchema = z.object({
  type: z.string(),
  link: z.string(),
})

export type CarHirePolicy = z.infer<typeof CarHirePolicySchema>
